export const LIVE2D_CONFIG = {
  widget: {
    enable: true,
    mobile: false,
    lazyLoad: false,
    position: 'right-bottom',
    width: 280,
    height: 350,
    zIndex: 9999
  },
  
  dialog: {
    enable: true,
    useHitokoto: true,
    hitokotoInterval: 300000,
    welcome: ['欢迎来到我的博客！', '今天天气不错呢~', '很高兴见到你！'],
    idle: ['你在看什么呢？', '有什么我可以帮你的吗？', '要不要喝杯茶？'],
    click: ['不要戳我啦~', '好痒啊~', '你在干嘛呢？']
  }
}